import { GenericTabView } from "./generic-tab";
import { GenericRelationView } from "./../partials/generic-relation";
import { CitedCaseRelationView } from "./../partials/cited-case-relation";
import { backboneViewProperties } from "../../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "div",
    childView: GenericRelationView
})
export class GenericListView extends Marionette.CollectionView<any, any> {

    public constructor(private options?) {
        super(options);
        this.listenTo(this.collection, "redraw", this.render);
    }

    public buildChildView(child, className, childViewOptions) {
        let view;
        if (this.options.itemViewType) {
            view = new this.options.itemViewType({model: child, template: this.getTemplate()});
        } else {
            view = new Marionette.ItemView<any>();
        }
        return view;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/generic-list.ts